import React from "react";
import { Text, TextProps } from "@looksrare/uikit";

export const InputError: React.FC<React.PropsWithChildren<TextProps>> = ({ children, ...props }) => (
  <Text color="text-error" textStyle="detail" {...props}>
    {children}
  </Text>
);
